import { ValueOf } from '@/types/util';

export const reservationStatus = {
  RESERVED: '予約',
  APPROVED: '承認済',
  DENIED: '却下',
  DECLINED: '取下げ',
  APPLIED: '予約適用済み',
} as const;

export type ReservationStatusKey = keyof typeof reservationStatus;
export type ReservationStatusValue = ValueOf<typeof reservationStatus>;

export const reservationStatusKeys = Object.keys(reservationStatus) as ReservationStatusKey[];

/** v-select用items */
export const reservationStatusItems = reservationStatusKeys
  .map((key) => ({
    title: reservationStatus[key],
    value: key,
  }));
